import PropTypes from 'prop-types';

import signatoryPlaceholder from './assets/signatory-placeholder.png';

const Signatory = ({ name }) => (
  <div className="signatory">
    <img
      className="signatory-signature"
      src={signatoryPlaceholder}
      alt={name}
    />
    <div className="signatory-name">
      {name}
    </div>
    <div className="signatory-credentials">
      <div>Professor</div>
      <div className="font-italic">UniversityX</div>
    </div>
  </div>
);

Signatory.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Signatory;
